import { type ReactNode } from "react";
import {
  NoFilesFoundIllustration,
  NofilesIllustration,
  SearchUserIllustration,
} from "vega-illustrations";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { Card } from "../../shadcn/card";

export enum CardVariant {
  NoResults = "no-results",
  NothingToFilter = "nothing-to-filter",
  SearchUser = "search-user",
}

export type EmptyCardProps = {
  description?: ReactNode | string;
  title?: string;
  variant?: CardVariant;
  illustration?: ReactNode;
  actions?: ReactNode;
  className?: string;
  noBorder?: boolean;
};

export const EmptyCard = ({
  description,
  title,
  variant = CardVariant.NoResults,
  illustration,
  actions,
  className,
  noBorder = false,
}: EmptyCardProps) => (
  <Card
    className={cnTwMerge(
      "flex flex-col gap-4 items-center justify-center w-full h-auto min-h-100 shadow-none p-6",
      { "border-0 rounded-none": noBorder },
      className,
    )}
  >
    {illustration ?? getIcon(variant)}
    <div className="text-center flex flex-col gap-2">
      {isTruthy(title) ? (
        <div className="text-lg md:text-2xl font-bold">{title}</div>
      ) : null}
      {isTruthy(description) ? (
        <div className="text-sm font-light text-text/secondary">
          {description}
        </div>
      ) : null}
    </div>
    {actions}
  </Card>
);
const getIcon = (type: CardVariant) => {
  switch (type) {
    case CardVariant.NoResults:
      return <NofilesIllustration />;
    case CardVariant.NothingToFilter:
      return <NoFilesFoundIllustration />;
    case CardVariant.SearchUser:
      return <SearchUserIllustration />;
    default:
      break;
  }
};
